import '@/assets/scss/index.scss'

import 'jquery/src/jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '@/assets/vendor/datatables/dataTables.bootstrap4.min';
import 'datatables/media/js/jquery.dataTables.min';

import i18n from "@/providers/LanguageProvider"
import router from "@/providers/RouterServiceProvider"
import store from "@/providers/StorageServiceProvider"
import '@/providers/FilterServiceProvider'
import '@/providers/PackageServiceProvider'

import Vue from 'vue'
import 'vue2-datepicker/locale/pt-br';
import App from './App.vue'

if (process.env.VUE_APP_APP_ENV !== 'prod') {
    Vue.config.productionTip = false
}

/* eslint-disable no-new */
new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
